class UnreachableCaseError extends Error {
  constructor(value: never) {
    super(`Unreachable case: ${value}`)
  }
}

export const exhaustiveMatchingGuard = (value: never): never => {
  throw new UnreachableCaseError(value)
}
